import { render, staticRenderFns } from "./PersonalPropertyQuestion.vue?vue&type=template&id=60d8f677"
import script from "./PersonalPropertyQuestion.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyQuestion.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyQuestion.vue?vue&type=style&index=0&id=60d8f677&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports